import { defineMessages } from 'react-intl';

export const StepsIntl = defineMessages({
  stepsDescription: {
    id: 'StepsIntl.stepDescription',
    defaultMessage:
      'In this section, you will be asked to take some measurements so that we can configure the camera to your specific needs.',
  },
  centimeters: {
    id: 'StepsIntl.centimeters',
    defaultMessage: 'cm',
  },
  titleStep_1: {
    id: 'StepsIntl.titleStep_1',
    defaultMessage: 'Select an image where the end of the road is clearly visible.',
  },
  stepRequirements_2: {
    id: 'StepsIntl.stepRequirements_2',
    defaultMessage: 'Enter the camera height (from the ground) in {value}.',
  },
  descriptionStep_3: {
    id: 'StepsIntl.descriptionStep_3',
    defaultMessage: 'Enter the rear axle width (from the outer edges of each tire) in {value}.',
  },
  descriptionStep_4: {
    id: 'StepsIntl.descriptionStep_4',
    defaultMessage: 'Enter the distance from the center of the windshield to the dashcam. If the dashcam is positioned directly in the center, input “0”. As viewed from the outside of the cabin looking in, if the dashcam is offset to the right, input the distance as a negative number. If it’s offset to the left, input the distance as a positive number. The diagram below would be a negative number.'
  },
  titleStep_5: {
    id: 'StepsIntl.titleStep_5',
    defaultMessage: 'Adjust the height of the red line to mark where the hood of the vehicle meets the road.',
  },
  titleStep_6: {
    id: 'StepsIntl.titleStep_6',
    defaultMessage: 'In the image below, adjust the bottom two red circles so that they overlap with the beginning of the left and right lane dividers that the vehicle is currently in. The top red circle should overlap with the road vanishing point. The white line between the circles should overlap with the edges of the left and right lane.',
  },
  titleStep_7: {
    id: 'StepsIntl.titleStep_7',
    defaultMessage: 'Confirm calibration layout. Red dashed lines should overlap with the edges of the left and right lane toward the horizon.',
  },
});
